var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFuria = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 427,
    height: 426,
    viewBox: "0 0 427 426",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "furia-image-a",
    points: ".682 .264 78.9 .264 78.9 239.075 .682 239.075"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "furia-image-c",
    points: "0 308.558 173.571 308.558 173.571 .713 0 .713"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "furia-image-e",
    cx: "68.525%",
    cy: "50.022%",
    r: "38.686%",
    fx: "68.525%",
    fy: "50.022%",
    gradientTransform: "matrix(.99765 0 0 1 .002 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EADFDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "90.68%",
    stopColor: "#D9DDE6",
    stopOpacity: 0.862
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EAF0F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "furia-image-f",
    cx: "19%",
    cy: "71.793%",
    r: "83.15%",
    fx: "19%",
    fy: "71.793%",
    gradientTransform: "scale(.99765 1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0.494
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "3.069%",
    stopColor: "#DDE8ED",
    stopOpacity: 0.615
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99.93%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "furia-image-g",
    cx: "79.211%",
    cy: "12.912%",
    r: "85.146%",
    fx: "79.211%",
    fy: "12.912%",
    gradientTransform: "matrix(.99765 0 0 1 .002 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C6D3DA",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DCE7FC",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M403.182879,241 C403.182879,137.996729 330.047828,52.1193173 233,32.7175579 L233,17 C336.353183,31.1043033 416,119.944684 416,227.435768 L403.182879,241 Z",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130 69.835)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BD3339",
    d: "M154.152344,107.603361 L165.714286,195.051792 L154.898101,234.447059 C154.898101,234.447059 100.297639,227.990946 82.1591802,228.159648 C62.2088238,228.344572 7.11046837,234.199412 7.11046837,234.199412 L6.42857143,107.603361 L154.152344,107.603361 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "135.714 163.899 125.513 164.365 86.07 166.167 46.63 164.365 36.429 163.899 40.563 176.639 46.378 204.572 49.417 205.239 55.228 223.004 49.029 241.724 46.914 248.116 41.597 264.174 46.5 291.455 80.593 291.455 83.795 283.738 87.46 283.738 91.451 291.455 91.984 291.455 125.643 291.455 130.546 264.173 125.229 248.116 123.113 241.724 116.915 223.004 122.728 205.231 125.737 204.572 131.562 176.594"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BD3339",
    points: "42.882 205.838 58.867 207.368 69.286 198.104 58.616 206.098 39.286 200.9 39.862 205.169"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BD3339",
    points: "116.403 205.838 100.419 207.368 90 198.104 100.67 206.098 120 200.9 119.424 205.169"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BD3339",
    points: "84.128 204.797 90 176.726 82.143 205.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DB3D35",
    points: "87.869 161.066 87.846 161.054 87.849 161.032"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DB3D35",
    points: "84.274 184.548 84.297 184.581 84.274 184.574"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DB3D35",
    points: "18.56 161.066 18.58 161.032 18.583 161.054"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DB3D35",
    points: "22.154 184.548 22.154 184.574 22.131 184.581"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "87.425 282.904 87.143 282.904 91.147 290.743 91.429 290.743"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C2C2C",
    d: "M26.2380768,210.699513 L17.9888609,211.896356 L30.8945078,202.396346 L40.4922365,176.621438 L46.3162955,204.514921 L49.3599269,205.181037 L55.1807365,222.922475 L59.7840935,236.62389 L26.2380768,210.699513 Z M46.7203078,290.742857 L41.8093382,263.516574 L50.0390574,238.753296 L122.385417,238.753296 L116.962121,222.672275 L122.784013,205.04998 L125.797317,204.453183 L131.631124,176.544537 L141.247266,202.3801 L154.153996,211.888774 L145.90478,210.69518 L113.841586,236.461423 L115.160854,242.905962 L164.285714,213.208009 L152.624599,186.757237 L135.790393,163.89916 L125.573106,164.364899 L86.0698039,166.163955 L46.5686678,164.364899 L36.3513814,163.89916 L19.5171755,186.75832 L7.85714286,213.208009 L58.7756875,243.804949 L41.5288042,263.766774 L46.4386907,290.742857 L69.2031036,290.742857 L46.7203078,290.742857 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD6A6",
    d: "M74.4802754 234.750993C82.0254726 237.125417 86.9370402 242.901628 85.448326 247.653727 83.9606929 252.405826 76.6371272 254.332675 69.09193 251.958251 61.5456517 249.583827 56.6351652 243.806532 58.1227982 239.055517 59.6115125 234.303418 66.9350782 232.376569 74.4802754 234.750993M98.207966 234.864437C90.6807958 237.360495 85.8615842 243.185349 87.4433966 247.875141 89.024124 252.563858 96.4080849 254.341223 103.935255 251.844089 111.46134 249.348031 116.280552 243.523177 114.699825 238.834461 113.118012 234.145744 105.735136 232.368378 98.207966 234.864437"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "84.286 283.73 42.656 289.168 47.01 291.135 72.607 298.078 43.94 302.857 13.571 298.015 19.342 281.661 41.142 264.376"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "19.38 289.602 100.22 282.797 101.429 292.979 29.436 308.558 13.571 298.604 19.351 282.192"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C2C2C",
    d: "M19.2857143,289.317647 L100,282.191597"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "20.714 291.629 29.471 290.585 100.224 285 101.181 292.881 101.429 292.828 100.224 282.904 29.471 288.489"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "87.143 283.73 128.773 289.168 124.419 291.135 94.692 297.868 127.489 302.857 157.857 298.015 152.087 281.661 130.286 264.376"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEBEB",
    d: "M89.2455279,293.593277 L122.130327,288.951625 C122.130327,288.951625 133.071711,284.219677 122.624168,276.490756 L98.9068252,279.130844 L87.8571429,283.998236 L89.2455279,293.593277 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "111.431 290.03 112.857 289.769 111.426 280.766 110 281.029"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "116.431 289.318 117.857 289.056 116.426 280.054 115 280.315"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "120.717 288.605 122.143 288.344 120.712 279.341 119.286 279.603"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "152.038 289.602 76.371 283.16 70 293.942 141.964 308.558 157.857 298.604 152.067 282.192"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "76.382 286.209 148.873 291.704 150 289.505 76.382 282.904 70 293.951 71.705 294.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2B99A",
    d: "M20.7142857,82.6621849 C14.7463937,83.1168333 10,88.2093261 10,94.3852364 L10,114.408041 C10,120.583951 14.7463937,125.676444 20.7142857,126.131092 L20.7142857,82.6621849 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M12.8571429,64.1344538 C12.8571429,64.1344538 -2.24176723,215.039064 2.27023732,225.895798 L12.8571429,171.062433 L12.8571429,64.1344538 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M23.5714286,65.4819827 C23.5714286,60.4766907 16.5048787,59.6763193 15.409372,64.556317 C9.00012618,93.1158606 1.69533021,131.665466 5.19244278,146.084034 C5.19244278,146.084034 7.53767795,75.2830228 20.9698661,69.3671867 C22.520593,68.6845487 23.5714286,67.199379 23.5714286,65.4819827 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M30,22.8033613 C13.9945036,25.2747091 3.0461079,103.750535 1.42857143,127.556303 C1.42857143,127.556303 14.0150609,54.317097 24.6367035,58.4277252 L30,22.8033613 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2B99A",
    d: "M86.0703472,7.83865546 C51.7767011,7.83865546 23.6831709,32.0173243 20.961539,62.7579117 L20.7631092,62.7579117 L20.7631092,62.7956673 L20.9572017,62.7956673 C20.9431056,62.9499258 20.920335,63.1020268 20.9084075,63.2562853 L20.7631092,63.257364 L20.7631092,63.3512136 L20.7631092,138.758801 C20.7631092,138.758801 18.5803821,147.655093 43.4036168,160.152187 L74.2285377,176.461516 C74.2285377,176.461516 85.6854152,182.393456 99.0517724,175.614713 L138.878681,154.221326 C138.878681,154.221326 150.000505,150.16422 151.286503,138.603464 L151.426379,138.494512 L151.426379,136.851605 L151.426379,63.257364 L151.426379,62.9272724 C151.428571,62.8830445 151.430717,62.8388165 151.426379,62.7956673 L151.426379,62.7579117 C148.704748,32.0162456 120.363993,7.83865546 86.0703472,7.83865546"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2B99A",
    d: "M151.428571,82.6621849 C157.396463,83.1168333 162.142857,88.2093261 162.142857,94.3852364 L162.142857,114.408041 C162.142857,120.583951 157.396463,125.676444 151.428571,126.131092 L151.428571,82.6621849 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.143)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "furia-image-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#furia-image-a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M0.78840411,93.1541897 L0.681965753,92.4899332 L0.759079256,94.5529088 C0.554891389,103.807137 0.810126223,113.304385 1.42594814,122.846997 C1.6279638,125.982504 1.87994031,129.122332 2.15472505,132.258919 L0.681965753,239.074612 L13.9107329,229.66161 C3.81972505,-36.1889811 77.2361243,44.8697593 77.2361243,44.8697593 L78.9000382,5.19582194 C20.4251947,-17.3230151 2.18839432,41.6640464 0.78840411,93.1541897",
    mask: "url(#furia-image-b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M167.799833 101.605968L168.141315 92.3468642 167.740397 94.8669723C166.681369 42.6095359 144.651416-15.9541068 89.3344703 5.11874574L84.2857143 44.7626904C84.2857143 44.7626904 166.387434-26.907673 151.740423 224.3239 151.740423 224.3239 152.148905 230.184366 152.587645 228.710075L153.854157 243.710924 169.285714 222.986678 166.973142 124.013884C167.482124 116.490255 167.777139 108.99037 167.799833 101.605968M80 38.3385109C80 38.3385109 10.082468 7.18166552 19.4291618 147.509244 19.4291618 147.509244-3.98541526-2.27573886 80 38.3385109"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M95,17.9967076 C95,17.9967076 165.917123,23.6272971 155.296062,154.635294 C155.296062,154.635294 187.473158,-0.994803884 95,17.9967076"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M116.428571 25.6318998C116.428571 25.6318998 159.020945 60.1271824 150.011668 147.509244 150.011668 147.509244 171.947725 14.240968 116.428571 25.6318998M160.714286 53.4453782C160.714286 53.4453782 176.892073 170.724555 172.953513 223.045378 172.953513 223.045378 159.425084 58.4361191 160.927151 56.8088442 162.43031 55.180491 160.714286 53.4453782 160.714286 53.4453782"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M160 45.6067227C160 45.6067227 177.597421 159.781034 171.617482 183.852101 171.617482 183.852101 170.769124 89.7982779 160 86.9375142L160 45.6067227zM87.6919274 146.159985C87.4346977 146.276166 86.7574347 146.681141 86.4285714 146.878096 86.1007935 146.681141 85.4224452 146.276166 85.1652155 146.159985 83.5588867 145.434127 80 150.149987 80 150.149987 84.4098068 150.808348 85.9303924 148.931741 86.4285714 148.143921 86.9278358 148.931741 88.4473361 150.884696 92.8571429 150.226334 92.8571429 150.226334 89.2982562 145.434127 87.6919274 146.159985"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M80,150.238094 C80,150.238094 86.1192446,156.873707 92.8571429,150.314697 L86.4285714,147.509244 L80,150.238094 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M97.8571429 102.937955C97.8571429 102.937955 108.870946 94.5268649 129.1424 102.54032 129.1424 102.54032 133.555491 104.258784 135.621999 105.465546 136.40167 105.260866 132.130239 102.957144 127.000197 99.9391722 127.000197 99.9391722 108.225365 89.7914958 97.8571429 102.937955M72.8571429 102.937955C72.8571429 102.937955 61.8433394 94.5268649 41.5718854 102.54032 41.5718854 102.54032 37.1587944 104.258784 35.092287 105.465546 34.3126156 105.260866 38.5840465 102.957144 43.7140891 99.9391722 43.7140891 99.9391722 62.4889202 89.7914958 72.8571429 102.937955"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DB3D35",
    points: "74.286 4.276 97.857 4.276 84.378 44.894 82.458 39.189"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEBEB",
    d: "M75.6301467,295.731092 L45.8771946,291.224995 C45.8771946,291.224995 36.5006322,285.952251 47.4633937,276.490756 L68.6290673,279.346871 L78.5714286,283.129943 L75.6301467,295.731092 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "49.311 205.838 65.295 207.368 75.714 198.104 65.044 206.098 45.714 200.899 46.291 205.169"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "122.832 205.838 106.848 207.368 96.429 198.104 107.099 206.098 126.429 200.899 125.852 205.169"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "126.271 204.797 132.143 176.726 124.286 205.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "45.872 204.797 40 176.726 47.857 205.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "55.093 223.045 116.902 223.045 118.571 228.034 53.571 227.945"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "49.286 288.247 50.781 288.605 52.857 279.7 51.362 279.341"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "53.571 288.96 55.067 289.318 57.143 280.412 55.647 280.054"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "57.857 290.385 59.353 290.743 61.429 281.838 59.933 281.479"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C2C2C",
    d: "M90.7308146,151.072269 C90.5242031,151.072269 89.9598583,151.423239 89.772137,151.469345 C90.5855962,151.671648 91.6765053,151.605782 91.6765053,152.319955 C91.6765053,153.035069 90.0991736,152.469564 89.2857143,152.670926 C89.4734357,152.717973 90.8642267,153.210084 91.0708383,153.210084 C92.1747344,153.210084 92.8571429,153.199734 92.8571429,152.319955 C92.8571429,151.440176 91.8347107,151.072269 90.7308146,151.072269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004256",
    d: "M154.285714,128.268908 L154.285714,128.268908 L154.285714,73.3983193 L154.285714,73.3983193 C148.762738,73.3983193 144.285714,77.8210314 144.285714,83.2756735 L144.285714,118.392634 C144.285714,123.847276 148.762738,128.268908 154.285714,128.268908"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF7FD",
    d: "M158.474362,74.2962606 C160.266934,75.0829047 161.428571,76.8885123 161.428571,78.8853782 L161.428571,100.833613 L161.428571,122.781849 C161.428571,124.778715 160.266934,126.583242 158.474362,127.369886 L156.428571,128.268908 L156.428571,100.833613 L156.428571,73.3983193 L158.474362,74.2962606 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004256",
    d: "M170.24192,91.8753881 C172.198903,92.3800462 173.571429,94.1920299 173.571429,96.2715694 L173.571429,100.834157 L173.571429,105.396745 C173.571429,107.475197 172.198903,109.287181 170.24192,109.791839 L162.142857,111.878992 L162.142857,100.834157 L162.142857,89.7882353 L170.24192,91.8753881 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#D3DEE4",
    points: "167.857 110.454 162.143 122.568 162.143 111.922"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "furia-image-d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#furia-image-c"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B6C0C7",
    points: "153.571 128.269 156.429 128.269 156.429 73.398 153.571 73.398",
    mask: "url(#furia-image-d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004256",
    d: "M19.2857143,128.268908 L19.2857143,128.268908 L19.2857143,73.3983193 L19.2857143,73.3983193 C24.8086902,73.3983193 29.2857143,77.8210314 29.2857143,83.2756735 L29.2857143,118.392634 C29.2857143,123.847276 24.8086902,128.268908 19.2857143,128.268908",
    mask: "url(#furia-image-d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF7FD",
    d: "M15.0970669,74.2962606 C13.3044946,75.0829047 12.1428571,76.8885123 12.1428571,78.8853782 L12.1428571,100.833613 L12.1428571,122.781849 C12.1428571,124.778715 13.3044946,126.583242 15.0970669,127.369886 L17.1428571,128.268908 L17.1428571,100.833613 L17.1428571,73.3983193 L15.0970669,74.2962606 Z",
    mask: "url(#furia-image-d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004256",
    d: "M3.32950904,91.8753881 C1.37252575,92.3800462 0,94.1920299 0,96.2715694 L0,100.834157 L0,105.396745 C0,107.475197 1.37252575,109.287181 3.32950904,109.791839 L11.4285714,111.878992 L11.4285714,100.834157 L11.4285714,89.7882353 L3.32950904,91.8753881 Z",
    mask: "url(#furia-image-d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#D3DEE4",
    points: "5.714 110.454 11.429 122.568 11.429 111.922",
    mask: "url(#furia-image-d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B6C0C7",
    points: "16.429 128.269 19.286 128.269 19.286 73.398 16.429 73.398",
    mask: "url(#furia-image-d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004256",
    d: "M168.571429,96.2016807 L161.334601,96.2016807 L161.334601,71.9173588 C161.334601,35.9545565 137.183314,18.4730441 87.5005417,18.4730441 C37.8166864,18.4730441 13.6653991,35.9545565 13.6653991,71.9173588 L13.6653991,96.2016807 L6.42857143,96.2016807 L6.42857143,71.9173588 C6.42857143,33.2005752 32.5082349,7.83865546 86.3034317,7.83865546 C140.098628,7.83865546 168.571429,33.2005752 168.571429,71.9173588 L168.571429,96.2016807 Z",
    mask: "url(#furia-image-d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004256",
    d: "M91.4285714,2.13781513 C76.0903969,2.13781513 57.3553154,3.86856208 42.8571429,12.3507234 C45.0396285,15.4004411 49.6021195,19.0120618 58.2224492,15.9226677 C64.7601385,13.5796181 72.7021721,12.1770053 79.1801714,11.3523805 C87.2849961,10.3207953 95.5721468,10.3207953 103.676971,11.3523805 C110.154971,12.1770053 118.097004,13.5796181 124.634694,15.9226677 C133.255023,19.0120618 137.817514,15.4004411 140,12.3507234 C125.501827,3.86856208 106.766746,2.13781513 91.4285714,2.13781513",
    mask: "url(#furia-image-d)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.5,
    cy: 212,
    fill: "url(#furia-image-e)",
    opacity: 0.142,
    rx: 212.5,
    ry: 212
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.5,
    cy: 212,
    fill: "url(#furia-image-f)",
    rx: 212.5,
    ry: 212
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.5,
    cy: 212,
    fill: "url(#furia-image-g)",
    stroke: "#DBE4ED",
    rx: 212.5,
    ry: 212
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFuria, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/furia.906b71e0.svg";
export { ForwardRef as ReactComponent };